import { Avatar } from "@mui/material";
import LogoWhite from "../../../assets/logos/logoWhite.svg";
import LogoBlack from "../../../assets/logos/logoBlack.svg";
import useTheme from "../../../hooks/useTheme";

const Logo = (props) => {
  const { theme } = useTheme();
  return (
    <Avatar
      src={theme !== "DARK" ? LogoWhite : LogoBlack}
      style={{ width: "98%", height: "98%", padding: "5px" }}
      variant="square"
    />
  );
};

export default Logo;
